export default __webpack_public_path__ + "images/39ac4703250a1d0fb15911c2c5f10174-generic_1_desktop.webp";